import React, { useEffect, useState } from "react";
import styles from "./CreateProduct.module.sass";
import TextInput from "../../../components/TextInput";
import nameAndDesc from "../../NewProduct/NameAndDescription/NameAndDescription.module.sass";
import Dropdown from "../../../components/Dropdown";
import { InputController } from "../../../hooks/input-controller";
import { UseApi } from "../../../hooks/use-api";
import { GetCategories } from "../../../Services/lib/admin";
import Modal from "../../../components/Modal";
import Schedule from "../../../components/Schedule";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import cn from "classnames";
import { GetCollectionsSimple } from "../../../Services/lib/nft";
import { GetAddressList } from "../../../Services/lib/brand";
import Icon from "../../../components/Icon";
import { useUser } from "../../../context";
import product from "../../../i11/Product";
import { templateProcessor } from "../../../Services/assets/template-processor";
import Disclaimer from "../../../components/Disclaimer";

import AllowPurchase from "./AllowPurchase";
import ImagesUpload from "../../../components/ImageInput/UploadImages";
import PaymentMethod from "../../../components/Product/PaymentMethod";

const optionsPurchase = ["Unique", "Standard"];
function isRegex(str) {
	if (!str) return false;
	var regex = /^[A-Za-z0-9\- ]+$/;
	return !regex.test(str);
}

const defCurrency = (currency) => {
	switch (currency) {
		case "GBP":
			return "£";
		case "USD":
			return "$";
		case "HKD":
			return "HKD";
		default:
			return currency || "$";
	}
};

const Validator = (measures, setCriterias) => {
	const { weight, height, width, length } = measures;
	const sizes = [
		parseFloat(width) || 0,
		parseFloat(height) || 0,
		parseFloat(length) || 0,
	].sort((a, b) => b - a);
	const longest = sizes[0];
	const girth = (sizes[1] + sizes[2]) * 2 + longest;
	console.log(girth);
	const body = {
		w: weight <= 150,
		lSize: longest <= 108,
		girth: girth <= 165,
	};
	setCriterias(body);
};

const Body = ({
	local,
	setLocal,
	createO,
	item,
	isDisable,
	setCriterias,
	criterias,
	isAuction,
	setAuction,
}) => {
	const { locale, brand } = useUser();
	const [{ data }, getCategories] = UseApi({
		service: GetCategories,
	});
	const [{ data: collections }, getCollection] = UseApi({
		service: GetCollectionsSimple,
	});
	const [{ data: addresses }, getAddresses] = UseApi({
		service: GetAddressList,
	});
	const dictionaryType = {
		hooson: "",
		EXPERIENCE_TOKEN: { title: "EXPERIENCE TOKEN" },
		PHYSICAL_TOKEN: { title: "PHYSICAL TOKEN" },
		ART_TOKEN: { title: "GENERAL TOKEN" },
	};

	const [measures, setMeasures] = useState({
		weight: local.shippingInfo?.weight || "",
		height: local.shippingInfo?.height || "",
		width: local.shippingInfo?.width || "",
		length: local.shippingInfo?.length || "",
	});
	const [dictionaryCate, setDictionaryCate] = useState({});
	const [dictionaryAddr, setDictionaryAddr] = useState({});
	const [dictionaryColle, setDictionaryColle] = useState({});

	const [purchase, setPurchase] = useState(local.type);
	const [category, setCategory] = useState(local.category);
	const [type, setType] = useState(local.tokenType);
	const [collection, setCollection] = useState(local.nftCollection);
	const [address, setAddress] = useState(
		local.shippingInfo?.pickupAddressID || ""
	);
	const { onChangeInput: changeName } = InputController("name", setLocal);
	const price = InputController("price", setLocal);
	const description = InputController("description", setLocal);
	const totalNFTs = InputController("totalNFTs", setLocal);
	const royalty_percent = InputController("royalties", setLocal);
	const skuNumber = InputController("skuNumber", setLocal);
	const weight = InputController("weight", setMeasures);
	const height = InputController("height", setMeasures);
	const width = InputController("width", setMeasures);
	const length = InputController("length", setMeasures);

	const setAuctionAmount = (value) => {
		setLocal((p) => ({
			...p,
			auctionIncrementType: { ...p.auctionIncrementType, value },
		}));
	};
	const setAuctionPrice = (value) => {
		setLocal((p) => ({
			...p,
			multiPrices: !value
				? []
				: [
						{
							price: value,
							currency: brand.defaultCurrency,
						},
				  ],
		}));
	};

	const {
		onOpen: startOpen,
		onClose: startClose,
		isOpen: startIsOpen,
	} = UseDisclosure();
	const {
		onOpen: endOpen,
		onClose: endClose,
		isOpen: endIsOpen,
	} = UseDisclosure();
	const [startDate, setStartDate] = useState(
		local.startDate === "" ? "" : new Date(local.startDate)
	);
	const [endDate, setEndDate] = useState(
		local.endDate === "" ? "" : new Date(local.endDate)
	);

	useEffect(() => {
		setLocal((p) => {
			return {
				...p,
				endDate,
				startDate,
			};
		});
	}, [endDate, startDate]);

	const HandleChange = (e) => {
		setLocal((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	useEffect(() => {
		setLocal((p) => {
			return {
				...p,
				type: purchase,
				category: category,
				nftCollection: collection,
				tokenType: type,
				shippingInfo: {
					...p.shippingInfo,
					pickupAddressID: address,
				},
			};
		});
	}, [purchase, category, collection, address, type]);

	useEffect(() => {
		setLocal((p) => {
			return {
				...p,
				shippingInfo: {
					...p.shippingInfo,
					...measures,
				},
			};
		});
	}, [measures]);

	useEffect(() => {
		Validator(measures, setCriterias);
	}, [measures]);

	const getCategories_ = async () => {
		const res = await getCategories();
		if (res) {
			const tmp = {};
			res.forEach((element) => {
				tmp[element._id] = element;
			});
			setDictionaryCate({ hooson: "", ...tmp });
		}
	};

	const getCollections_ = async () => {
		const res = await getCollection();
		if (res) {
			const tmp = {};
			res.forEach((element) => {
				tmp[element._id] = { title: element.name };
			});
			setDictionaryColle({ hooson: "", ...tmp });
		}
	};

	const getAddresses_ = async () => {
		const res = await getAddresses();
		if (res) {
			const tmp = {};
			res.forEach((element) => {
				tmp[element._id] = {
					title: element.AddressLineString + ", " + element.Region,
				};
			});
			setDictionaryAddr({ hooson: "", ...tmp });
		}
	};
	useEffect(() => {
		getCategories_();
		getCollections_();
		getAddresses_();
	}, []);

	return (
		<>
			<div
				className={cn(nameAndDesc.description, {
					[nameAndDesc.Disabled]: isDisable,
				})}
			>
				<TextInput
					disabled={isDisable}
					defaultValue={local.name}
					// className={nameAndDesc.field}
					label={product[locale].name}
					name="title"
					type="text"
					value={local.name}
					required
					onChangeInput={(b) => {
						changeName(b);
					}}
					pattern="[A-Za-z0-9\- ]+"
				/>
				<p className={styles.validation}>
					{isRegex(local.name) && product[locale].name_val_text}
				</p>
				<Dropdown
					isDisabled={isDisable}
					dictionary={dictionaryCate}
					className={styles.field}
					label={product[locale].category}
					// tooltip="Category"
					value={category}
					setValue={setCategory}
					options={data ? ["hooson", ...data.map((e) => e._id)] : []}
				/>
				<div style={{ marginTop: "24px" }}>
					<Dropdown
						isDisabled={isDisable}
						className={styles.field}
						label={product[locale].collection}
						value={collection}
						setValue={setCollection}
						dictionary={dictionaryColle}
						options={
							collections
								? ["hooson", ...collections.map((e) => e._id)]
								: []
						}
					/>
				</div>
				<div style={{ marginTop: "24px" }}>
					<Dropdown
						isDisabled={isDisable}
						className={styles.field}
						label={product[locale].token_type}
						// tooltip="Token Type"
						value={type}
						setValue={setType}
						dictionary={dictionaryType}
						options={[
							"hooson",
							"PHYSICAL_TOKEN",
							"EXPERIENCE_TOKEN",
							"ART_TOKEN",
						]}
					/>
				</div>
				<div style={{ marginTop: "24px" }}>
					<TextInput
						disabled={isDisable}
						className={styles.editor}
						defaultValue={local.description}
						label={product[locale].short_desc}
						name="description"
						type="text"
						textarea
						// tooltip="Maximum 100 characters. No HTML or emoji allowed"
						required
						{...description}
					/>
				</div>
				<div className={styles.label_}>
					{product[locale].description}
					{/* <Tooltip
						className={styles.tooltip_}
						title={product[locale].description}
						icon="info"
						place="right"
					/> */}
				</div>
				<button
					onClick={createO}
					type="button"
					className="button-small"
				>
					{product[locale].detailed_desc}
				</button>
			</div>
			<div
				className={cn(styles.price, {
					[nameAndDesc.Disabled]: isDisable,
				})}
				style={{ marginTop: "24px" }}
			>
				<TextInput
					disabled={isDisable}
					className={styles.field}
					defaultValue={local.royalties}
					label={product[locale].royalty_per}
					name="royalty-percent"
					required
					type="number"
					step="any"
					min="0"
					currency="%"
					{...royalty_percent}
				/>
				{type === "PHYSICAL_TOKEN" ? (
					<>
						<TextInput
							disabled={isDisable}
							className={styles.field}
							defaultValue={local.skuNumber}
							label={product[locale].sku}
							name="SKU number"
							required
							type="text"
							// tooltip="SKU number"
							{...skuNumber}
						/>
						<div style={{ marginBottom: "24px" }}>
							<Dropdown
								isDisabled={isDisable}
								dictionary={dictionaryAddr}
								className={styles.field}
								label={product[locale].where_pick}
								// tooltip={product[locale].where_pick}
								value={address}
								setValue={setAddress}
								options={
									addresses
										? [
												"hooson",
												...addresses.map((e) => e._id),
										  ]
										: []
								}
							/>
						</div>
						<div className={styles.label_}>
							{product[locale].package_info}
						</div>
						<div className={styles.label_}>
							<Disclaimer>
								<div style={{ fontSize: "12px" }}>
									{["w", "lSize", "girth"].map((e) => {
										return (
											<div
												className={
													styles[
														criterias[e]
															? "pass"
															: "fail"
													]
												}
												key={e}
											>
												{product[locale].upsCriteria[e]}
											</div>
										);
									})}
								</div>
							</Disclaimer>
						</div>
						<div className={styles.myfields}>
							<TextInput
								disabled={isDisable}
								className={styles.field}
								placeholder={product[locale].height}
								name="amount"
								defaultValue={measures.height}
								type="number"
								min="0"
								currency="Inch"
								{...height}
							/>
							<TextInput
								disabled={isDisable}
								className={styles.field}
								placeholder={product[locale].width}
								name="amount"
								defaultValue={measures.width}
								type="number"
								min="0"
								currency="Inch"
								{...width}
							/>
							<TextInput
								disabled={isDisable}
								className={styles.field}
								placeholder={product[locale].length}
								name="amount"
								defaultValue={measures.length}
								type="number"
								min="0"
								currency="Inch"
								{...length}
							/>
							<TextInput
								disabled={isDisable}
								className={styles.field}
								placeholder={product[locale].weight}
								name="amount"
								defaultValue={measures.weight}
								type="number"
								min="0"
								currency="Lbs"
								{...weight}
							/>
						</div>
					</>
				) : null}
				<Dropdown
					className={styles.field}
					label={product[locale].sale_type}
					tooltip={product[locale].saleTypeTooltip}
					value={isAuction ? "Auction" : "Sale"}
					setValue={(e) => {
						setLocal((p) => ({
							...p,
							price: e === "Auction" ? "0" : "",
						}));
						setAuction(e === "Auction");
					}}
					disabled={isDisable}
					isDisabled={
						item ? item.bids.length !== 0 : false || isDisable
					}
					options={["Auction", "Sale"]}
				/>
				{isAuction ? (
					<p className={styles.reminder}>
						{product[locale].auctionReminder}
					</p>
				) : null}
				<div className={styles.field}>
					{isAuction ? (
						<>
							<div className={styles.fieldset}>
								<div className={styles.test}>
									<div className={styles.field}>
										<TextInput
											disabled={isDisable}
											defaultValue={local.price}
											label={
												product[locale][
													isAuction
														? "minPrice"
														: "amount"
												]
											}
											name="amount"
											type="number"
											min="0"
											// tooltip="Amount"
											required
											currency={defCurrency(
												brand.defaultCurrency
											)}
											// {...price}
											onChangeInput={setAuctionPrice}
											value={
												local?.multiPrices[0]?.price ||
												""
											}
										/>
									</div>
								</div>
								<div className={styles.test}>
									<div className={styles.field}>
										<TextInput
											// tooltip="Choose bid step"
											currency={defCurrency(
												brand.defaultCurrency
											)}
											label={"Bid step"}
											value={
												local.auctionIncrementType.value
											}
											onChangeInput={setAuctionAmount}
											disabled={isDisable}
											type="number"
											min={1}
											required
										/>
									</div>
								</div>
							</div>
							<div
								style={{
									marginTop: "12px",
								}}
							>
								{parseFloat(local.price) === 0 ? (
									<Disclaimer>
										<div
											style={{
												fontSize: "12px",
												opacity: 0.5,
											}}
										>
											Define a minimum bid price to set
											the base bid for your auction. If
											you'd like to give your bidders the
											flexibility to choose the initial
											bid, simply leave the value at 0.00.
										</div>
									</Disclaimer>
								) : null}
							</div>
						</>
					) : (
						<AllowPurchase
							local={local}
							setLocal={setLocal}
							isDisable={isDisable}
						/>
					)}
				</div>
				{isAuction ? (
					<Dropdown
						className={cn(styles.field, nameAndDesc.Disabled)}
						label={product[locale].type}
						// tooltip="Type"
						value="Unique"
						disabled={true}
						isDisabled={true}
						options={["Unique"]}
					/>
				) : (
					<Dropdown
						className={styles.field}
						label={product[locale].type}
						// tooltip="Type"
						value={purchase}
						setValue={setPurchase}
						disabled={isDisable}
						isDisabled={
							item ? item.bids.length !== 0 : false || isDisable
						}
						options={optionsPurchase}
					/>
				)}
				{local.type !== "Unique" &&
					local.type !== "Open" &&
					!isAuction && (
						<div style={{ marginTop: "24px" }}>
							<TextInput
								disabled={isDisable}
								className={styles.field}
								defaultValue={local.totalNFTs}
								label={product[locale].total_supp}
								// tooltip="Total supply"
								type="number"
								min="0"
								required
								{...totalNFTs}
							/>
							{(item ? item.bids.length !== 0 : false) && (
								<div className={styles.soldInfo}>
									{templateProcessor(
										{ count: item.bids.length || 0 },
										product[locale].sold_num
									)}
								</div>
							)}
						</div>
					)}
				{!isAuction && local.type === "Unique" && (
					<PaymentMethod
						isDisable={isDisable}
						setLocal={setLocal}
						local={local}
					/>
				)}
				<div className={styles.fieldset}>
					<div className={styles.test}>
						<div
							className={cn(styles.field)}
							onClick={() => {
								if (!isDisable) startOpen();
							}}
						>
							<TextInput
								disabled={isDisable}
								label={product[locale].start_d}
								name="Start date"
								type="text"
								value={startDate.toLocaleString()}
								onChangeInput={() => {
									if (!isDisable) startOpen();
								}}
							/>
						</div>
						{isDisable ? null : (
							<button
								type="button"
								className={cn(`button button-stroke-red`)}
								onClick={() => {
									if (!isDisable) setStartDate("");
								}}
							>
								{/* Delete */}
								<Icon name="trash" size="24" />
							</button>
						)}
					</div>
					{(local.type !== "Unique" && local.type !== "Open") ||
					isAuction ? (
						<div className={styles.test}>
							<div
								className={styles.field}
								onClick={() => {
									if (!isDisable) endOpen();
								}}
							>
								<TextInput
									disabled={isDisable}
									label={product[locale].end_d}
									name="End date"
									type="text"
									required
									value={endDate.toLocaleString()}
									onChangeInput={() => {
										if (!isDisable) endOpen();
									}}
								/>
							</div>
							{isDisable ? null : (
								<button
									type="button"
									className={cn(`button button-stroke-red`)}
									onClick={() => {
										if (!isDisable) setEndDate("");
									}}
								>
									<Icon name="trash" size="24" />
								</button>
							)}
						</div>
					) : null}
				</div>
				{/* <div className={styles.price} style={{ marginTop: "24px" }}>
					<ImageInput
						isDisabled={isDisable}
						aspect_ratio={1}
						where="TEMPLATES"
						callBack={HandleChange}
						className={styles.field}
						label={product[locale].image}
						required
						// tooltip="Image"
						initial={local.image}
					/>
				</div> */}
				<br />
				<ImagesUpload
					initialIMGList={local?.image_list || []}
					initialImage={local?.image}
					callBack={HandleChange}
					isDisabled={isDisable}
					spect_ratio={1}
					label={product[locale].image}
				/>
			</div>

			{/* // open date modl */}
			<Modal visible={startIsOpen} onClose={startClose}>
				<Schedule
					onClick={startClose}
					startDate={startDate}
					setStartDate={setStartDate}
				/>
			</Modal>
			<Modal visible={endIsOpen} onClose={endClose}>
				<Schedule
					onClick={endClose}
					startDate={endDate}
					setStartDate={setEndDate}
				/>
			</Modal>
		</>
	);
};

export default Body;
